import UserDataService from '../../../../Shared/Assets/userdata-service';
import EnquiryStore from './../common/enquiry-store';
import EventBus, { EventName } from '../../../../Shared/Assets/event-bus';
import { empty, onceOnly } from '../../../../Shared/Assets/utils';
import DealerAvailabilityRenderer from './dealer-availability-renderer';

export default class EnquiryForm {
    constructor(options) {
        this._handleSubmit = this._handleSubmit.bind(this);
        this._sendEnquiry = this._sendEnquiry.bind(this);
        this._initSearchQuery = this._initSearchQuery.bind(this);
        this._populateBlockoInfo = this._populateBlockoInfo.bind(this);
        this._hideInterstateConfirmationForm = this._hideInterstateConfirmationForm.bind(this);
        this._showInterstateConfirmationForm = this._showInterstateConfirmationForm.bind(this);
        this._handleEnquirySubmittedEvent = this._handleEnquirySubmittedEvent.bind(this);
        this._handleEventTriggerBlockoReject = this._handleEventTriggerBlockoReject.bind(this);
        this._handleFinanceEligibilityResponded = this._handleFinanceEligibilityResponded.bind(this);
        this._checkFinanceEligibility = this._checkFinanceEligibility.bind(this);

        this.eventBus = new EventBus();
        this.enquiryStore = new EnquiryStore();
        this.userDataService = new UserDataService();
    }

    init(formElement) {
        this.formElement = formElement;
        this.$form = $(formElement);
        this.body = $('html, body');
        this.$errorMessageBox = this.$form.find(".error-message-block");
        this.$submitButtons = this.$form.find("button[type='submit'],input[type='submit']");
        this._setupValidationBehaviour();
        this.$form.on('submit', this._handleSubmit);
        this._initShowOnHover();
        this._initInterstateEnquiryConfirmationForm();
        this._initPostCodeInput();
        this._initSearchQuery();
        this._initEventListener();
        this._checkFinanceEligibility();
        this._initAccordion();
        this._initCheckMark();
        this._initOnChange();
    }

    _setupValidationBehaviour() {
        this.$form.on('blur', ':text', function (e) {
            var $target = $(e.target);
            $target.val($target.val().trim());
        });

        // Ensure all validation done after trimming data
        $.each($.validator.methods, function (key, value) {
            $.validator.methods[key] = function () {
                if (arguments.length > 0) {
                    arguments[0] = $.trim(arguments[0]);
                }

                return value.apply(this, arguments);
            };
        });
    }

    _initAccordion() {
        let acc = this.$form.find('.divCls > .accordion');
        let i;
        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.parentNode.nextElementSibling;
                if (panel.style.display === "block") {
                    panel.style.display = "none";
                } else {
                    panel.style.display = "block";
                }
            });
        }
    }

    _initCheckMark() {
        let ele = this.$form.find('.divCls > .markCls');
        if(this.$form.find(".contactPrefilledCls").css("display") === "none"){
            ele.removeClass( "circle" );
            ele.addClass( "disableCircle" );
        }else{
            ele.removeClass( "disableCircle" );
            ele.addClass( "circle" );
        }
    }

    _initOnChange() {
        let inputs = this.$form.find('.inputCls');
        let ele = this.$form.find('.divCls > .markCls');
        let form = this.$form;
        let i;
        for (i = 0; i < inputs.length; i++) {
            inputs[i].addEventListener("input", function () {
                if (form.valid()){
                    ele.removeClass( "disableCircle" );
                    ele.addClass( "circle" );
                }else{
                    ele.removeClass( "circle" );
                    ele.addClass( "disableCircle" );
                }
            });
        }
    }

    _initShowOnHover() {
        let divBlock = this.$form.find(".show-on-hover");
        if (divBlock.length == 0) return;
        divBlock.hide();
        this.$form.on('mouseover', () => {
            if (!divBlock.is(":visible")) {
                divBlock.slideDown();
                this.$form.off("mouseover");
            }
        });
    }

    _initInterstateEnquiryConfirmationForm() {
        if (!this.formElement.btnCancelInterstateEnquiry)
            return;
        this.hfInterstateEnquiryConfirmed = this.formElement.InterstateEnquiryConfirmed;
        this.interstateConfirmationForm = $(this.$form.find(".interstate-enquiry-confirmation"));
        this.mainEnquiryForm = $(this.$form.find(".main-enquiry-section"));
        this.formElement.btnCancelInterstateEnquiry.addEventListener('click', evt => {
            this._hideInterstateConfirmationForm();
            this.hfInterstateEnquiryConfirmed.value = "False";
        });
        this.formElement.btnConfirmInterstateEnquiry.addEventListener('click', evt => {
            this.hfInterstateEnquiryConfirmed.value = "True";
        });
    }

    _initPostCodeInput() {
        let formElement = this.formElement;
        let dealerAvailabilityReact = formElement.querySelector("[data-react-dealer-availability]");
        if (dealerAvailabilityReact) {
            let hasDealerAvailability = dealerAvailabilityReact.getAttribute("data-react-dealer-availability") === "True";
            dealerAvailabilityReact.removeAttribute("data-react-dealer-availability");
            let data = {
                mode: "dealer-availability",
                formElement: formElement,
                postcode: formElement.Postcode.value,
                dealerApiUrl: dealerAvailabilityReact.getAttribute("data-dealer-api-url"),
                postcodeElement: formElement.Postcode,
                placement: dealerAvailabilityReact.getAttribute("data-placement"),
                hasDealerAvailability: hasDealerAvailability
            }

            new DealerAvailabilityRenderer(dealerAvailabilityReact, data).render();
        }

        let detachedPostcodeInput = formElement.querySelector("[data-react-post-code-input]");
        if (detachedPostcodeInput) {
            detachedPostcodeInput.removeAttribute("data-react-post-code-input");
            let data = {
                mode: "post-code-input",
                formElement: formElement,
                postcodeElement: formElement.Postcode,
                placement: formElement.EnquiryLocation.value
            }

            new DealerAvailabilityRenderer(detachedPostcodeInput, data).render();
        }

        let carConnectReact = formElement.querySelector("[data-react-car-connect]");
        if (carConnectReact) {
            carConnectReact.removeAttribute("data-react-car-connect");
            let data = {
                mode: "car-connect",
                formElement: formElement,
                postcode: formElement.Postcode.value,
                postcodeElement: formElement.Postcode,
                suburbInfoUrl: carConnectReact.getAttribute("data-suburb-info-url"),
                placement: carConnectReact.getAttribute("data-placement")
            }

            new DealerAvailabilityRenderer(carConnectReact, data).render();
        }

        let enquiryFormWrappers = document.querySelectorAll(".enquiry-form");
        for (let i = 0; i < enquiryFormWrappers.length; i++) {
            enquiryFormWrappers[i].classList.remove("d-none");
        }
    }

    _initSearchQuery() {
        if (empty(this.formElement.SearchQuery)) return;
        let networkId = this.formElement.NetworkId.value;
        if (sessionStorage) {
            var lastSearch = sessionStorage.getItem(networkId);
            if (!empty(lastSearch) && lastSearch != "null") {
                this.formElement.SearchQuery.value = lastSearch;
            }
        }
    }

    _initEventListener() {
        this.eventBus.handle(EventName.EnquiryThankYouResponded, this._handleEnquirySubmittedEvent);
        this.eventBus.handle(EventName.EventTriggerBlockoReject, this._handleEventTriggerBlockoReject);
        this.eventBus.handle(EventName.FinanceEligibilityResponded, this._handleFinanceEligibilityResponded);
        this.eventBus.handle(EventName.GenericEnquiryFormError, this._handleGenericEnquiryFormError);
    }

    _handleSubmit(evt) {
        evt.preventDefault();

        if (window.optimizelyUtil)
            window.optimizelyUtil.track("click-enquiryform-submit");

        if (!this.$form.valid())
            return false;

        if (this.formElement.SkipCollectingBlocko.value.toUpperCase() !== "TRUE") {
            this._populateBlockoInfo(evt.target);
        }

        this._populateSherlockoFingerprint(evt.target);

        this._populateTags(evt.target);
        this._populateDiscoveredProperties(evt.target);

        this._sendEnquiry(evt.target);

        return false;
    }

    _populateBlockoInfo(form) {
        if (typeof userdata === 'undefined' || typeof userdata.p_data !== 'function') {
            return;
        }

        userdata.p_data(form.BlockoInfo.id);
    }

    _populateSherlockoFingerprint(form) {
        if (window.fingerprint)
            $(form.SherlockoFingerprint).val(window.fingerprint);
    }

    _populateTags(form) {
        if (!sessionStorage) return;
        let tags = sessionStorage.getItem(form.NetworkId.value + "-tags");
        if (tags) {
            form.Tags.value = tags;
        }
    }

    _populateDiscoveredProperties(form) {
        const xprops = [...document.querySelectorAll("input[data-enquiry-xprop][type=\"hidden\"]")];
        form.DiscoveredProperties.value = [...new Set(xprops.map(node => `${node.name}=${node.value}`))]
            .join("&");
    }

    _sendEnquiry(form) {
        let url = form.getAttribute("actionUrl");

        if (typeof csn !== "undefined" && csn.baseUrl) {
            url = csn.baseUrl + url;
        }

        let $form = $(form);
        let $this = this;
        let enquiryData = this._getEnquiryData($form);

        this.$errorMessageBox.text("");
        this._showLoading($form);
        $.ajax({
            url: url,
            type: "POST",
            data: $form.serialize(),
            dataType: "json",
            success: response => {
                if (enquiryData.RememberDetails === 'false') {
                    this.enquiryStore.forget();
                } else {
                    // As we might send other types data than enquiry so we need to call userdataservice to store them
                    this.userDataService.saveData(response.userData);
                    // using enquiry service to control enquiry in one place and override what userdataservice saved
                    this.enquiryStore.saveFromUserData(response.userData);
                }

                // fire tracking events
                $this.eventBus.dispatch(EventName.EnquirySentSuccess, {
                    enquiryData: enquiryData,
                    enquiryResponse: response
                });

                if (!empty(response.redirectUrl)) {
                    // fire save car event
                    $this.eventBus.dispatch(EventName.EnquirySaveCar, $this.formElement.NetworkId.value);
                    // save postcode in session
                    if (sessionStorage) sessionStorage.setItem("cmp.ret.enq.last-postcode", $this.formElement.Postcode.value);
                    parent.window.location.href = response.redirectUrl;
                    return;
                }

                $this._hideLoading($form);

                if (!empty(response.interStateConfirmation)) {
                    $this._showInterstateConfirmationForm(response.interStateConfirmation);
                    return;
                }

                this.body.animate({ scrollTop: this.$form.offset().top - 255 }, 300);

                $this.eventBus.dispatch(EventName.EnquirySaveCar, $this.formElement.NetworkId.value);

                if (!empty(response.thankYouHtml)) {
                    // fire event to show thank you message on all enquiry forms
                    $this.eventBus.dispatch(EventName.EnquiryThankYouResponded, response);
                }
            },
            error: errorDetail => {
                $this._showErrorSummary(errorDetail);
                $this._hideLoading($form);
            }
        });
    }

    _getEnquiryData($form) {
        let formDataArray = $form.serializeArray();
        let enquiryData = [];
        for (let i = 0; i < formDataArray.length; i++) {
            if (formDataArray[i].name in enquiryData) continue;
            enquiryData[formDataArray[i].name] = formDataArray[i].value;
        }
        return enquiryData;
    }

    _showLoading($form) {
        this.$submitButtons
            .addClass('loading')
            .prop("disabled", true);
    }

    _hideLoading($form) {
        this.$submitButtons
            .removeClass('loading')
            .prop("disabled", false);
    }

    _showErrorSummary(error) {
        let errorMessage = "";
        console.error("error:", error);
        if (empty(error.responseJSON) || empty(error.responseJSON.errors)) {
            console.error(error);
            errorMessage = $("#EnquiryFailedErrorMessage").html();
        }
        else {
            let errorMessageList = [];
            for (let i = 0; i < error.responseJSON.errors.length; i++) {
                errorMessageList.push(error.responseJSON.errors[i].message);
            }
            errorMessage = errorMessageList.join(", ");
        }

        this.$errorMessageBox
            .html(errorMessage)
            .show();
    }

    _showInterstateConfirmationForm(confirmationData) {
        this.$form.find(".proximity-message").text(confirmationData.proximityMessage);
        this.body.animate({ scrollTop: this.$form.offset().top - 255 }, 300);
        this.mainEnquiryForm.hide();
        this.interstateConfirmationForm.show();
    }

    _hideInterstateConfirmationForm() {
        this.mainEnquiryForm.show();
        this.interstateConfirmationForm.hide();
    }

    _handleEnquirySubmittedEvent(eventData) {
        let thankyouHtmlWrapper = null;
        if (!empty(eventData.thankYouHtml)) {
            thankyouHtmlWrapper =
                this.$form
                    .children(".enquiry-form")
                    .empty()
                    .append(eventData.thankYouHtml);
            $(".postcode-panel-section").remove();
        }
        if (!empty(eventData.mediaMotiveHtml)
            && !window.triggeredMediaMotiveAdPostEnquiry
            && thankyouHtmlWrapper) {
            window.triggeredMediaMotiveAdPostEnquiry = true;
            thankyouHtmlWrapper.append(eventData.mediaMotiveHtml);
        }
    }

    _handleEventTriggerBlockoReject() {
        let form = this.formElement;
        if (sessionStorage) {
            let sessionKey = form.NetworkId.value + "-tags";
            let tags = sessionStorage.getItem(sessionKey);
            if (!/ViewNumber_Blocko_Reject/.test(tags)) {
                tags = tags
                    ? tags + ",ViewNumber_Blocko_Reject"
                    : "ViewNumber_Blocko_Reject";
                sessionStorage.setItem(sessionKey, tags);
            }
        }
        else {
            if (!/ViewNumber_Blocko_Reject/.test(form.Tags.value)) {
                form.Tags.value = form.Tags.value
                    ? form.Tags.value + ",ViewNumber_Blocko_Reject"
                    : "ViewNumber_Blocko_Reject";
            }
        }
    }

    _checkFinanceEligibility() {
        let stockId = this.formElement.NetworkId.value;
        onceOnly(() => {
            $("[check-finance-eligibility-url]", this.formElement).each(function () {
                let checkUrl = this.getAttribute("check-finance-eligibility-url");
                $.ajax({
                    url: checkUrl + "?id=" + stockId,
                    success: function (result) {
                        (new EventBus()).dispatch(EventName.FinanceEligibilityResponded, result)
                    },
                    error: function (error) {
                        console.error(error);
                    }
                });
            });
        }, 100, "CheckFinanceEligibilityViaAjax");
    }

    _handleFinanceEligibilityResponded(eventData) {
        if (eventData.isShowFinanceCheckbox) {
            let financeCheckboxSection = $("[check-finance-eligibility-url]", this.formElement);
            financeCheckboxSection.show();
            if (empty(eventData.tooltipContent)) {
                $("[tooltip-display]", financeCheckboxSection).hide();
                return;
            }

            $("[tooltip-display]", financeCheckboxSection).tooltip({
                title: eventData.tooltipContent
            });

            $("[aria-label-tooltip]").attr("aria-label", eventData.tooltipContent);
        }

        if (eventData.dealerFinanceId !== null) {
            this.formElement.DealerFinanceId.value = eventData.dealerFinanceId;
            this.formElement.DealerFinanceVersion.value = eventData.dealerFinanceVersion;
        }

        if (eventData.provider !== null) {
            this.formElement.FinanceProvider.value = eventData.provider;
            this.formElement.FinanceProviderDisplayName.value = eventData.providerDisplayName;
            this.formElement.IsExternalFinance.value = eventData.isExternalFinance;
        }
    }

    _handleGenericEnquiryFormError = (errorMessage) => {
        if (errorMessage) {
            this.$errorMessageBox
                .text(errorMessage)
                .show();
        }
        else {
            this.$errorMessageBox
                .text("")
                .hide();
        }
    }
}